import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'
import ArrowDownSvg from 'resources/svg/icons/angle-left.svg'
import { FlexWrapper } from 'lib/ui/components'

export const Arrow: any = styled.div`
  &::before {
    content: '';
    width: 12px;
    height: 12px;
    background: url(${ArrowDownSvg}) no-repeat center;
    background-size: 6px;
    display: block;
    transition: transform 0.2s ease-in-out;
    cursor: pointer;
    transform: ${(props: any) => props.open ? 'rotate(90deg)' : 'rotate(270deg)'};
  }
`

export const BottomActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  border-top: 1px solid ${props => props.theme.palette.general.greyLight};
`

export const Container = styled.div`
  .order {
    cursor: pointer;
    border: 1px solid ${props => props.theme.palette.general.greyLight};
    margin-bottom: 35px;
    outline: none;
    transition: border-color 300ms ease, box-shadow 300ms ease;

    &:hover,
    &:focus {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }

    &:focus {
      border-color: ${props => props.theme.palette.primary.alpha};
    }

    &__heading {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 40px 0;
    }

    &__group {
      display: flex;
    }

    &__status {
      display: flex;
      width: 100%;
      padding: 0 60px;
      box-sizing: border-box;

      > div {
        color: ${props => props.theme.palette.general.greyDark};
        font-style: italic;
        margin: 0 0 20px;
      }
    }

    &__info {
      margin: 0 60px;
      max-width: 200px;

      strong {
        display: block;
        margin-bottom: 20px;
      }

      ${bp('sm')`
        margin-top: 20px;
      `}
    }

    &__statusColumn {
      align-self: flex-end;
    }

    &__item {
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 15px;
      ${bp('sm')`
        flex-wrap: wrap;
        justify-content: center;
      `}
      .item {
        &__image {
          width: 110px;
          height: 110px;
          height: auto;
          margin: 0 20px 0 60px;

          span {
            display: block;
            width: 100px;
            height: 110px;
            background: no-repeat 50% 50% / contain;
          }
        }

        &__info {
          width: 30%;
          margin-right: 60px;
          ${bp('sm')`
            margin: 30px auto;
          `}

          > div {
            margin-bottom: 10px;
          }

          .name {
            font: ${font('default', 'bold', '16px/1.5')};
            margin-bottom: 10px;
          }
        }

        &__price {
          margin: 0 60px;
          font-size: 15px;
        }
      }
    }

    &__arrow {
      margin: auto 30px 5px auto;
    }

    &__content {
      margin-left: auto;
      border-top: 1px solid ${props => props.theme.palette.general.greyLight};
    }
  }
`

export const RatingWrapper = styled(FlexWrapper)`
  align-items: center;
  margin-bottom: 20px;

  > div > span {
    display: none;
  }

  .react-rater-star {
    width: 15px;
    height: 15px;
    background-size: 15px;
  }
`

export const RatingBrand = styled(FlexWrapper)`
  display: flex;
  flex-direction: column;

  span {
    color: ${props => props.theme.palette.primary.alphaDark};
    text-decoration: none;

    :hover {
      color: ${props => props.theme.palette.general.dark};
    }
  }
`
